
/**
 * @authorsTT
 * @date    2018-09-07 10:07:23
 */
import store from '@/store/store';
import fetch from '@/util/axios/fetch';
export default{
    //自定义下拉框注册全局变量
    customerSelectArray:{},
    lset(name, val) {
        window.localStorage.setItem(name, val);
    },
    lget(name) {
        return window.localStorage.getItem(name);
    },
    loginInfo(callback, res) {
        fetch({
            url   : "/web/user/get_userinfo",
            method: "get",
            res   : res
        }).then( result => {
            try{
                let json = result.data,
                flag = json.result=="success"?true:false;

                if(json.result=="success"){
                    let data = json.data;
                    store.dispatch('userStore/setUserNameAsy',data.username);
                    store.dispatch('userStore/setUserIdAsy',data.user_id);
                    store.dispatch('userStore/setUserTypeAsy',data.usertype);
                    store.dispatch('userStore/setGradeListAsy',data.grade_list);
                    store.dispatch('userStore/setSchoolNameAsy',data.school_name?data.school_name:"校园照明");
                    store.dispatch('userStore/setPermissionListAsy',data.permission_list);
                    store.dispatch('userStore/setLastloginTimeAsy',data.lastlogin_time);
                    if(data.avatar!="" && data.avatar){
                        store.dispatch('userStore/setLogoAsy',data.avatar);
                    }else{
                        data.avatar=require("@/assets/img/logo.png");
                        store.dispatch('userStore/setLogoAsy',data.avatar);
                    }
                    if(data.banner!="" && data.banner){
                        store.dispatch('userStore/setBannerAsy',data.banner);
                    }else{
                        data.banner=require("@/assets/img/banner.png");
                        store.dispatch('userStore/setBannerAsy',data.banner);
                    }
                }else{

                }

                !callback || callback(flag, flag?json.data:json);
            }catch(e){
                console.log("get_userinfo: "+ e);
            }
        });
    },
    /**
     * [亮度配置范围]
     * @return {[type]} [description]
     */
    getBrightnessRange:function(){
        let _config = [
            // {"text":"关","value":0,"info":"关"},
            {"text":"10","value":5,"info":"10"},
            {"text":"20","value":10,"info":"20"},
            {"text":"30","value":15,"info":"30"},
            {"text":"40","value":20,"info":"40"},
            {"text":"50","value":25,"info":"50"},
            {"text":"60","value":30,"info":"60"},
            {"text":"70","value":35,"info":"70"},
            {"text":"80","value":40,"info":"80"},
            {"text":"90","value":45,"info":"90"},
            {"text":"100","value":50,"info":"100"},
        ];
        return _config;
    },
    /**
     * [照度配置范围]
     * @return {[type]} [description]
     */
    getLuxRange:function(){
        let _config = [
            {"text":"200","value":200,"info":"200"},
            {"text":"300","value":300,"info":"300 (教室标准)"},
            {"text":"400","value":400,"info":"400"},
            {"text":"500","value":500,"info":"500"},
            {"text":"750","value":750,"info":"750"},
            {"text":"1000","value":1000,"info":"1000"},
        ];
        return _config;
    },
    /**
     * [色温配置范围]
     * @return {[type]} [description]
     */
    getWcRange:function(){
        let _config = [
            /*{"text":2500,"value":0},
            {"text":2750,"value":1},
            {"text":3000,"value":2},
            {"text":3250,"value":3},
            {"text":3500,"value":4},
            {"text":3750,"value":5},
            {"text":4000,"value":6},
            {"text":4250,"value":7},
            {"text":4500,"value":8},
            {"text":4750,"value":9},
            {"text":5000,"value":10},*/
            {"text":"3500","value":3500,"info":"3500 (小学低年级标准)"},
            {"text":"3700","value":3700,"info":"3700"},
            {"text":"4000","value":4000,"info":"4000 (小学高年级标准)"},
            {"text":"4300","value":4300,"info":"4300"},
            {"text":"4700","value":4700,"info":"4700"},
            {"text":"5000","value":5000,"info":"5000 (初中及以上标准)"},
        ];
        return _config;
    },
    IEVersion() {
        const userAgent = navigator.userAgent, //取得浏览器的userAgent字符串
            isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1, //判断是否IE<11浏览器
            isEdge = userAgent.indexOf("Edge") > -1 && !isIE, //判断是否IE的Edge浏览器
            isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;

        if(isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if(fIEVersion == 7) {
                return 7;
            } else if(fIEVersion == 8) {
                return 8;
            } else if(fIEVersion == 9) {
                return 9;
            } else if(fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }
        } else if(isEdge) {
            return 222;//edge
        } else if(isIE11) {
            return 11; //IE11
        }else{
            return -1;//不是ie浏览器
        }
    },
    millisecondsForDate(transData,transFlag){
        var oldTime = (new Date(transData)).getTime(); //得到毫秒数
        var newTime = new Date(oldTime); //得到普通的时间
        var tmpYear = newTime.getFullYear();
        var tmpMonth= newTime.getMonth()+1;
        var tmpDay  = newTime.getDate();

        var tmpCycleTime={
            "year":tmpYear,
            "month":tmpMonth<10?"0"+(tmpMonth):tmpMonth,
            "day":tmpDay<10?"0"+(tmpDay):tmpDay
        };

        if(typeof transFlag =="undefined" || transFlag == false){
            return (tmpCycleTime.year)+"-"+(tmpCycleTime.month)+"-"+(tmpCycleTime.day);;
        }else{
            return tmpCycleTime;
        }
    },
    getPreMonth(date,type) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
            year2 = parseInt(year2) - 1;
            month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if(type=="end"){
            day2=days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    },
    dataChartTime() {
        let data = new Date(),
            time = data.getTime(),
            vDate = new Date(time),
            tmpFullYear = vDate.getFullYear(),
            tmpMonth = vDate.getMonth()+1;

        return {
            s: this.millisecondsForDate(Date.getDaysInMonthFrist(tmpFullYear, tmpMonth)),
            e: this.millisecondsForDate(Date.getDaysInMonthLast(tmpFullYear, tmpMonth)),
            t: this.millisecondsForDate(new Date()),
        }
    },
    /**
     * [设置自定义下拉框显示/隐藏切换属性]
     * @param {[type]} transKey   [description]
     * @param {[type]} transValue [description]
     */
    setCustomerSelectArray(transKey,transValue){
        Vue.set(this.customerSelectArray,transKey,transValue);
    },
    /**
     * [获取自定义下拉框组件的显示/隐藏属性]
     * @param  {[type]} transKey [description]
     * @return {[type]}          [description]
     */
    getCustomerSelectArray(transKey){
        if(transKey){
            return (this.customerSelectArray)[transKey];
        }else{
            return this.customerSelectArray;
        }
    },
}


// WEBPACK FOOTER //
// ./src/globalConfig/globalConfig.js